import { FolderOffOutlined } from '@mui/icons-material';
import { Box, Paper, Stack, Typography } from '@mui/material';

import AccountSwitchToggle from 'components/v2/accountSwitchToggle';

import useAccountSwitcher from 'hooks/useAccountSwitcher';
import useTranslate from 'hooks/useTranslate';

export function NoApplicationPlaceholder() {
    const { translate } = useTranslate();
    const { canSwitch, accounts, selected } = useAccountSwitcher();
    const showSwitch = canSwitch && accounts.length > 1 && Boolean(selected);

    return (
        <Paper
            elevation={0}
            sx={{
                width: '100%',
                maxWidth: 440,
                px: { xs: 2.5, sm: 4.5 },
                py: { xs: 3, sm: 5 },
                borderRadius: 3,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                boxShadow: '0 18px 44px rgba(15, 23, 42, 0.08), 0 2px 10px rgba(15, 23, 42, 0.04)',
            }}
        >
            <Stack spacing={3} sx={{ alignItems: 'center', textAlign: 'center' }}>
                <Box
                    sx={{
                        width: 76,
                        height: 76,
                        borderRadius: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'primary.main',
                        bgcolor: 'action.selected',
                        boxShadow: (theme) => `0 0 0 8px ${theme.palette.action.hover}`,
                    }}
                >
                    <FolderOffOutlined sx={{ fontSize: 34 }} />
                </Box>

                <Stack spacing={1} sx={{ maxWidth: 320 }}>
                    <Typography
                        variant="h5"
                        sx={{ fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.3 }}
                    >
                        {translate('noApplicationsTitle')}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.65 }}>
                        {translate('noApplicationsDescription')}
                    </Typography>
                </Stack>

                {showSwitch ? (
                    <Stack spacing={1.25} sx={{ width: '100%', pt: 0.5 }}>
                        <Typography variant="body2" color="text.secondary">
                            {translate('noApplicationsSwitchHint')}
                        </Typography>
                        <AccountSwitchToggle />
                    </Stack>
                ) : null}
            </Stack>
        </Paper>
    );
}

export default NoApplicationPlaceholder;
